import { useMemo } from 'react';
const fullClipboard = window.navigator.clipboard;
const write = (items) => fullClipboard.write(items.map((item) => new ClipboardItem({ [item.mimeType]: item.data })));
const writeText = (data) => fullClipboard.writeText(data);
export function useClipboard() {
    return useMemo(() => (Object.assign(Object.assign({}, fullClipboard), { write: write, writeText: writeText })), []);
}
